import env from 'enviro';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
import { getQueryParams, getSavedQueryParams, stringifyQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
import { formatPublicExperimentationForQueryParams } from '../experimentationUtils';
const createSignupQuery = signupIntent => {
  if (!signupIntent) return {};
  return {
    [SignupQueryKeys.Intent]: signupIntent
  };
};
const cleanUpQueryParams = queryParams => {
  const queryParamsMap = {
    currency: queryParams.currencyCode,
    'hubs_signup-url': queryParams.hubsSignupUrl,
    'hubs_signup-cta': queryParams.hubsSignupCta,
    dtbId: queryParams.dtbId,
    dtb_source: queryParams.dtbSource,
    hsSeats: queryParams.isUngatedForSeats,
    experimentKey: queryParams.experimentKey,
    experimentParameter: queryParams.experimentParameter,
    uuid: queryParams.uuid,
    flags: queryParams.flags
  };
  Object.keys(queryParamsMap).forEach(key => {
    if (queryParamsMap[key] === undefined || queryParamsMap[key] === null) {
      delete queryParamsMap[key];
      return;
    }
    if (Array.isArray(queryParamsMap[key])) {
      return;
    }
    if (typeof queryParamsMap[key] !== 'string') {
      queryParamsMap[key] = `${queryParamsMap[key]}`;
    }
  });
  return queryParamsMap;
};
// Not to be confused  with hubs signup url, this is the actual URL
// of the signup app we're sending the user to
export const generateSignupUrlWithQueryParams = ({
  signupType,
  signupIntent,
  queryParams,
  experiments
}) => {
  // For persisting query params for user journey, e.g. `hubs_content` & `hubs_content-cta`, which can come from a different page
  const defaultSavedQueryParams = getSavedQueryParams(getQueryParams());

  // Query params set by the pricing page
  const queryParamsMap = cleanUpQueryParams(queryParams);
  const stringifiedQueryParams = stringifyQueryParams(Object.assign({}, defaultSavedQueryParams, queryParamsMap));
  const experimentParamString = formatPublicExperimentationForQueryParams(experiments);
  const signupQuery = createSignupQuery(signupIntent);
  const baseUrl = new SignupUrlGenerator(signupType, {
    query: signupQuery,
    env: env.isQa() || getIsQAProxy() ? 'qa' : 'prod'
  }).getUrl();
  const initialQueryParamPunctuation = signupIntent ? '&' : '?';
  return `${baseUrl}${initialQueryParamPunctuation}${stringifiedQueryParams}${experimentParamString ? `&${experimentParamString}` : ''}`;
};